// RDS
import Text from '@ramsey-design-system/text';

export type DiscussionQuestion = {
  icon: string;
  text: string;
};

function DiscussionQuestions({
  questions
}: {
  questions: DiscussionQuestion[];
}) {
  return (
    <div className="flex flex-col gap-3 pt-1.5">
      <ul className="flex flex-col gap-3">
        {questions.map(({ icon, text }) => (
          <li key={text} className="flex items-start gap-3">
            <img
              src={icon}
              alt=""
              className="mt-0.5 h-8 w-8 shrink-0 object-contain"
            />
            <Text className="text-5 leading-lg">{text}</Text>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DiscussionQuestions;
